<template>
  <div class="odmik-vsebine-nastavtive-telefonija">
    <div v-loading="loadingData" v-if="telefonskaStevilka !== null">
      <div style="padding-bottom: 30px;">
        <div>
          <p class="navadno-besedilo">
            Za brezskrbno uporabo omogočamo številne nastavitve mobilne telefonije, s katerimi imate nadzor
            nad porabo storitev. <br> Preverite tudi koristne informacije o uporabi podatkovnega prometa v
            <a :href="nadzorPorabeMobilneTelefonije" class="primarna-barva">
              tujini
            </a>.
          </p>
        </div>
        <div style="padding-top: 20px" v-if="!jeMobilniTopPaket">
          <div>
            <p class="open-sans-20pt">
              Blokade mobilnega interneta
            </p>
          </div>
        </div>
        <div style="padding-top: 30px" v-if="!jeMobilniTopPaket">
          <p class="navadno-besedilo">
            Omejitev prenosa podatkov omogoča, da sistem samodejno blokira podatkovni promet ob doseženi
            porabi 61 € na podatkovnem prenosu. <br v-if="formaOrientacija === 'left'">
            Izbirna meja podatkovnega prenosa v slovenskih omrežjih pomeni, da se podatkovni prenos blokira,
            ko poraba izven zakupljenih enot preseže izbrano vrednost meje. <br v-if="formaOrientacija === 'left'">
            Vrednost meje je izražena v EUR z DDV.
          </p>
        </div>
        <div style="clear: both; padding-top: 30px" v-if="!jeMobilniTopPaket">
          <el-form label-width="400px" :label-position="formaOrientacija">
            <el-form-item label="Omejitev prenosa podatkov">
              <el-select
                v-model="telefonskaStevilka.mednarodnePodatkovneBlokade.izbranaBlokada"
                placeholder="Izberite"
                class="velikost-izbirnika-prenosa"
                @change="spremebaMednarodnePodatkovneBlokade"
                v-loading="telefonskaStevilka.mednarodnePodatkovneBlokade.loadingChange"
                :disabled="telefonskaStevilka.mednarodnePodatkovneBlokade.loadingChange"
              >
                <el-option
                    v-for="(omejitev, omejitevKey) in telefonskaStevilka.mednarodnePodatkovneBlokade.mozneBlokade"
                    :label="omejitev.label"
                    :key="omejitevKey"
                    :value="omejitev.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="Meje podatkovnega prenosa v slovenskih omrežjih">
              <el-select
                placeholder="Izberite"
                v-model="telefonskaStevilka.nacionalnePodatkovneBlokade.izbranaBlokada"
                class="velikost-izbirnika-prenosa"
                @change="spremebaNacionalnePodatkovneBlokade"
                v-loading="telefonskaStevilka.nacionalnePodatkovneBlokade.loadingChange"
                :disabled="telefonskaStevilka.nacionalnePodatkovneBlokade.loadingChange"
              >
                <el-option
                  v-for="(omejitev, omejitevKey) in telefonskaStevilka.nacionalnePodatkovneBlokade.mozneBlokade"
                  :label="omejitev.label"
                  :key="omejitevKey"
                  :value="omejitev.id"
                />
              </el-select>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div v-if="voiceFeaturesEnabled">
        <hr class="hr-stil" v-if="!jeMobilniTopPaket">
        <div class="odmik-locenih-vsebin" :key="telefonskaStevilka.blokadaKomercialnihSporocil.stevilka">
          <div>
            <div>
              <p class="open-sans-20pt">
                Blokada komercialnih sporočil
              </p>
            </div>
          </div>
          <div class="odmik-statusa-blokade-komercialnih-sporocil">
            <b>STATUS:</b>
            {{
              telefonskaStevilka.blokadaKomercialnihSporocil.blokirano == false
              ? 'Nimate blokiranih komercialnih sporočil.'
              : 'Imate blokirana komercialna sporočila.'
            }}
          </div>
          <div class="postavitev-gumb">
            <el-button
              type="primary"
              class="gumb-potrdi"
              @click="spremeniBlokado"
              v-loading="telefonskaStevilka.blokadaKomercialnihSporocil.loading"
              :disabled="telefonskaStevilka.blokadaKomercialnihSporocil.loading"
            >
              {{telefonskaStevilka.blokadaKomercialnihSporocil.blokirano == false ? 'NASTAVI BLOKADO' : 'ODSTRANI BLOKADO'}}
            </el-button>
          </div>
          <div class="odmik-zgodovine-komercialnih-sporocil" v-if="telefonskaStevilka.blokadaKomercialnihSporocil.trenutniPrikazZgodovine.length !== 0">
            <div class="open-sans-17pt">
              Zgodovina blokade komercialnih sporočil
            </div>

            <div style="padding-top: 10px;">
              <el-table
                :data="telefonskaStevilka.blokadaKomercialnihSporocil.trenutniPrikazZgodovine">
                <el-table-column
                  label="Datum od"
                  prop="datum_od">
                </el-table-column>
                <el-table-column
                  label="Datum do"
                  prop="datum_do">
                </el-table-column>
                <el-table-column
                  label="Opomba"
                  prop="opomba">
                </el-table-column>
              </el-table>
              <div class="text-center" style="cursor: pointer;">
                <el-pagination
                  @current-change="naloziTrenutnoPrikazanoZgodovino"
                  :hide-on-single-page="true"
                  :page-size="4"
                  layout="prev, pager, next"
                  :total="telefonskaStevilka.blokadaKomercialnihSporocil.zgodovina.length * 4"
                  small>
                </el-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr class="hr-stil">
      <div class="odmik-locenih-vsebin">
        <div>
          <div>
            <p class="open-sans-20pt">
              Omrežje, v katerem želite uporabljati podatke
            </p>
          </div>
        </div>
        <div style="padding-top: 30px">
          <p class="navadno-besedilo">
            Izberite želene kombinacije omrežij, v katerih želite uporabljati prenos podatkov. <br>
            Preverite cenik gostovanja v tujih omrežjih na
            <a :href="mobilnoGostovanje" class="primarna-barva" target="_blank">
              https://www.t-2.net/mobilno-gostovanje
            </a>
          </p>
        </div>
        <div v-if="telefonskaStevilka.roamingPrifili.seznam !== null && telefonskaStevilka.roamingPrifili.seznam.length > 0">
          <div class="postavitev-roaming-profili" v-loading="telefonskaStevilka.roamingPrifili.loading">
            <div v-for="(profil) in telefonskaStevilka.roamingPrifili.seznam">
              <div>
                <span>
                  <el-checkbox
                    :disabled="telefonskaStevilka.roamingPrifili.vklopljenOperaterskiRoamingProfil"
                    v-model="profil.vklopljen"
                    @change="vklopiProfil(profil)"
                  >
                  </el-checkbox>
                </span>
                <span class="navadno-besedilo odmik-naziva">
                  {{profil.naziv}}
                </span>
              </div>
            </div>
          </div>
          <div style="padding-top: 30px" v-if="telefonskaStevilka.roamingPrifili.vklopljenOperaterskiRoamingProfil && kontaktniPodatki !== null">
            <i>
              <img :src="ikonaWarning" class="Icon-awesome"/>
            </i>
            <b>STATUS</b>: Nastavitev je zaklenjena zaradi preseženega limita ali drugih zlorab.
            Za več informacij pokličite {{ kontaktniPodatki.T2_SUPPORT_TEL_ST }}.
          </div>
        </div>
      </div>
      <div
        v-if="voiceFeaturesEnabled"
        v-loading="telefonskaStevilka.zaporeKlicev.loadingItems || telefonskaStevilka.zaporeKlicev.loadingSave"
      >
        <hr class="hr-stil">
        <div style="padding-top: 30px">
          <p class="open-sans-20pt">
            Zapore klicev
          </p>
        </div>
        <div style="padding-top: 30px">
          <p class="navadno-besedilo">
            Z vklopom onemogočite klice na izbrano možnost.
          </p>
        </div>
        <div style="clear: both; padding-top: 15px;">
          <div v-for="(zapora,index) in telefonskaStevilka.zaporeKlicev.zaporeKlicev">
            <el-form label-width="400px" :label-position="formaOrientacija" v-if="zapora.value === undefined" class="custom-prikaz">
              <el-form-item :label=zapora.name>
                <el-radio-group
                  v-model="zapora.active"
                  v-if="typeof zapora.value === 'undefined'"
                  @change="reloadDisabledAttributes()"
                >
                  <el-radio :label="true" :disabled="zapora.disabled">
                    Da
                  </el-radio>
                  <el-radio :label="false" :disabled="zapora.disabled">
                    Ne
                  </el-radio>
                </el-radio-group>
                <el-tooltip
                  v-if="zapora.disabledMessage !== ''"
                  :content="zapora.disabledMessage"
                  placement="top-end"
                >
                  <el-icon
                    class="el-icon-info ml-2"
                    style="font-size: 18px; color: orange; cursor: pointer"
                  />
                </el-tooltip>
              </el-form-item>
            </el-form>
            <div v-if="typeof zapora.value !== 'undefined'" style="padding-top: 30px">
              <p class="navadno-besedilo">
                Zapore klicev lahko uporabnik nastavlja tudi preko mobilnega aparata, vendar mora poznati geslo.
                Če želite onemogočiti, da bi uporabnik številke sam spreminjal
                <br class="new-line"/> nastavitve, spremenite kodo.
                Zapore odhodnih klicev onemogočijo odhodne klice, zapore dohodnih pa dohodne, torej sprejemanje klicev.
              </p>
              <div style="padding-top: 30px">
                <el-form label-width="400px" :label-position="formaOrientacija">
                  <el-form-item class="normal-line" :label="zapora.name">
                    <el-input
                      placeholder="Vnesite geslo" v-model="zapora.value"
                      class="velikost-inputa-koda-za-spremembo-zapora"
                      :disabled="zapora.disabled"
                    >
                    </el-input>
                  </el-form-item>
                </el-form>
              </div>
            </div>
          </div>
        </div>
        <div class="postavitev-gumb">
          <el-button type="primary" @click="spremebaZaporeKlicev()"
                     class="gumb-potrdi">
            SHRANI SPREMEMBE
          </el-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {povezave} from '../../../../../../assets/js/Povezave/povezave'
import {Button, Select, Option, Input, Loading, MessageBox, Pagination, Tooltip} from 'element-ui'
import {PrikazVsebine} from 'src/assets/js/globalne_funkcije/SplosneGlobalneFunkcije/SirinaOkna.js'
import {KontaktniPodatkiEnum} from '../../../../../../assets/js/Enum/KontaktniPodatkiEnum'
import TelefonskaStevilka from '../../../../../../assets/js/Prikljucek/Telefonija/Umts/TelefonskaStevilka'

export default {
  name: 'Blokade',
  components: {
    [Button.name]: Button,
    [Select.name]: Select,
    [Option.name]: Option,
    [Loading.name]: Loading,
    [Input.name]: Input,
    [Pagination.name]: Pagination,
    [Tooltip.name]: Tooltip
  },
  mixins: [PrikazVsebine],
  props: {
    idSimKartice: Number,
    izbranPrikljucek: [Number, String],
    izbranaTelefonska: String,
    jeMobilniTopPaket: Boolean,
    voiceFeaturesEnabled: Boolean
  },
  data () {
    return {
      clientAgent: null,
      formaOrientacija: 'left',
      mejnaSirina: 1200,
      mobilnoGostovanje: '',
      nadzorPorabeMobilneTelefonije: '',
      ikonaWarning: '/static/img/Domov/Icon-awesome-exclamation-triangle-black.png',
      kontaktniPodatki: null,
      seznamPodatkovZgodovineSporocil: [],
      dolzinaZgodovineKomercialnihSporocil: null,
      seznamZgodovineKomercialnihSporocil: [],
      telefonskaStevilka: null,
      loadingData: false
    }
  },
  mounted () {
    this.kontaktniPodatki = KontaktniPodatkiEnum
    this.mobilnoGostovanje = povezave.BASE_URL_MOBILNO_GOSTOVANJE
    this.nadzorPorabeMobilneTelefonije = povezave.BASE_URL_NADZOR_PORABE_MOBILNE_TELEFONIJE
    this.$nextTick(function () {
      window.addEventListener('resize', this.SirinaOknaPresegaVrednost)
      window.dispatchEvent(new Event('resize'))
    })
  },
  methods: {
    async initialLoad () {
      if (this.izbranPrikljucek !== null && this.izbranaTelefonska !== null) {
        this.loadingData = true
        this.telefonskaStevilka = TelefonskaStevilka.getInstance(Number(this.izbranPrikljucek), this.izbranaTelefonska, this.idSimKartice)
        let promisses = [
          this.telefonskaStevilka.blokadaKomercialnihSporocil.loadData(true),
          this.telefonskaStevilka.roamingPrifili.loadList(true),
          this.telefonskaStevilka.zaporeKlicev.loadData(true)
        ]
        if (!this.jeMobilniTopPaket) {
          promisses.push(this.telefonskaStevilka.mednarodnePodatkovneBlokade.loadBlokad(true))
          promisses.push(this.telefonskaStevilka.nacionalnePodatkovneBlokade.loadBlokad(true))
        }
        await Promise.all(promisses)
        this.loadingData = false
      }
    },
    async spremebaMednarodnePodatkovneBlokade () {
      try {
        await this.telefonskaStevilka.mednarodnePodatkovneBlokade.spremeni()
        let paramObvestilo = {message: 'Uspešno posodobljena mednarodna podatkovna blokada.'}
        this.ShowSuccessMessage(paramObvestilo)
      } catch (e) {
        e.duration = 0
        this.ShowErrorMessage(e)
      }
    },
    async spremebaNacionalnePodatkovneBlokade () {
      try {
        await this.telefonskaStevilka.nacionalnePodatkovneBlokade.spremeni()
        let paramObvestilo = {message: 'Uspešno nastavljena izbrana blokada prenosa podatkov.'}
        this.ShowSuccessMessage(paramObvestilo)
      } catch (e) {
        e.duration = 0
        this.ShowErrorMessage(e)
      }
    },
    async spremeniBlokado () {
      try {
        if (this.telefonskaStevilka.blokadaKomercialnihSporocil.blokirano === true) {
          await this.telefonskaStevilka.blokadaKomercialnihSporocil.deblokiraj()
          this.ShowSuccessMessage({message: 'Uspešno odstranjena blokada komercialnih sporočil.'})
        } else {
          await this.telefonskaStevilka.blokadaKomercialnihSporocil.blokiraj()
          this.ShowSuccessMessage({message: 'Uspešno nastavljena blokada komercialnih sporočil.'})
        }
      } catch (e) {
        e.duration = 0
        this.ShowErrorMessage(e)
      }
    },
    async vklopiProfil (profil) {
      MessageBox.confirm('Ali ste prepričani, da želite spremeniti omrežje v katerem želite uporabljati podatke?',
        'Opozorilo', {
          confirmButtonText: 'Da',
          cancelButtonText: 'Prekliči',
          confirmButtonClass: 'gumb-potrdi',
          cancelButtonClass: 'gumb-preklici',
          customClass: 'opozorilo-dialog'
        }).then(async () => {
        try {
          await this.telefonskaStevilka.roamingPrifili.spremeniProfil(profil)
          this.ShowSuccessMessage({message: 'Uspešno posodobljeno omrežje.'})
        } catch (e) {
          e.duration = 0
          this.ShowErrorMessage(e)
        }
      }).catch(async (err) => {
        err.duration = 0
        this.ShowErrorMessage(err)
        try {
          await this.telefonskaStevilka.roamingPrifili.loadList(true)
        } catch (e) {
          e.duration = 0
          this.ShowErrorMessage(e)
        }
      })
    },
    reloadDisabledAttributes () {
      this.telefonskaStevilka.zaporeKlicev.reloadDisabledAttributes()
    },
    async spremebaZaporeKlicev () {
      try {
        await this.telefonskaStevilka.zaporeKlicev.save()
        this.ShowSuccessMessage({message: 'Izbrana zapora klicev uspešno nastavljena.'})
      } catch (e) {
        e.duration = 0
        this.ShowErrorMessage(e)
      }
    },
    naloziTrenutnoPrikazanoZgodovino (stran) {
      this.telefonskaStevilka.blokadaKomercialnihSporocil.naloziTrenutnoPrikazanoZgodovino(stran)
      this.$forceUpdate()
    }
  },
  watch: {
    izbranaTelefonska: {
      immediate: true,
      handler (val) {
        this.telefonskaStevilka = null
        this.initialLoad()
      }
    },
    orientacija: function (val) {
      this.formaOrientacija = val
    }
  }
}
</script>
<style scoped src="../../../../../../../static/css/Nastavitve/Telefonija/NastavitveMobilnaTelefonija/Blokade.css">
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Nastavitve/NastavitveTelefonije/NastavitveMobilnaTelefonija/Blokade.vue